import { render, staticRenderFns } from "./StaticRegisterEditCard.vue?vue&type=template&id=d5b03e16&scoped=true"
import script from "./StaticRegisterEditCard.vue?vue&type=script&lang=js"
export * from "./StaticRegisterEditCard.vue?vue&type=script&lang=js"
import style0 from "./StaticRegisterEditCard.vue?vue&type=style&index=0&id=d5b03e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b03e16",
  null
  
)

export default component.exports